import type { AdminCrewReportByDesksChartProps } from "../../models/admin-crew-report.models";
import { formatAdminCrewReportPeopleCount } from "../../utils/admin-crew-report-statistics.utils";
import { ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportDeskBarChart from "./AdminCrewReportDeskBarChart";

const AdminCrewReportByDesksChart = ({ statistics, view }: AdminCrewReportByDesksChartProps) => {
  const viewLabels = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view];

  return (
    <AdminCrewReportDeskBarChart
      title={viewLabels.byDesksTitle}
      categories={statistics.categories}
      emptyStateMessage={viewLabels.byDesksEmptyState}
      accessibleTotalText={`${formatAdminCrewReportPeopleCount(statistics.totalCrewCount, view)} in total`}
      accessibleValueKind={view}
      cardDataTest="admin-crew-report-by-desks-card"
      cardTestId="admin-crew-report-by-desks-card"
      visualizationTestIdPrefix="admin-crew-report-desk"
    />
  );
};

export default AdminCrewReportByDesksChart;
